import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import JobCardList from "@/pages/JobCardList";
import JobCardForm from "@/pages/JobCardForm";
import JobCardView from "@/pages/JobCardView";
import Admin from "@/pages/Admin";
import PublicTrack from "@/pages/PublicTrack";
import Customers from "@/pages/Customers";
import ArtworkMaster from "@/pages/ArtworkMaster";
import MaterialsMaster from "@/pages/MaterialsMaster";
import Machines from "@/pages/Machines";
import ChecklistMaster from "@/pages/ChecklistMaster";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/track/:id" element={<PublicTrack />} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/job-cards" element={<ProtectedRoute><JobCardList /></ProtectedRoute>} />
          <Route path="/job-cards/new" element={<ProtectedRoute><JobCardForm /></ProtectedRoute>} />
          <Route path="/job-cards/:id" element={<ProtectedRoute><JobCardView /></ProtectedRoute>} />
          <Route path="/job-cards/:id/edit" element={<ProtectedRoute><JobCardForm /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
          <Route path="/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
          <Route path="/products" element={<ProtectedRoute><ArtworkMaster /></ProtectedRoute>} />
          <Route path="/artwork-master" element={<ProtectedRoute><ArtworkMaster /></ProtectedRoute>} />
          <Route path="/materials" element={<ProtectedRoute><MaterialsMaster /></ProtectedRoute>} />
          <Route path="/machines" element={<ProtectedRoute><Machines /></ProtectedRoute>} />
          <Route path="/checklist-master" element={<ProtectedRoute><ChecklistMaster /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
